import { Decimal } from '@mlm/shared';
import type { ExpiryBucket, StockLot } from '../../lib/api';

/** "Aisle 3 / Rack B", or a dash when the product has no location yet. */
export function locationLabel(aisle: string | null, rack: string | null): string {
  return [aisle, rack].filter(Boolean).join(' / ') || '-';
}

export const BUCKET_LABEL: Record<ExpiryBucket, string> = {
  expired: 'Expired',
  within_7: 'Within 7 days',
  within_30: 'Within 30 days',
  later: 'Later',
  none: 'No expiry',
};

/** How long a lot has left, in words a stock clerk would use. */
export function daysLeftLabel(daysLeft: number | null): string {
  if (daysLeft === null) return 'No expiry';
  if (daysLeft < 0) return `${Math.abs(daysLeft)} day${daysLeft === -1 ? '' : 's'} ago`;
  if (daysLeft === 0) return 'Today';
  return `${daysLeft} day${daysLeft === 1 ? '' : 's'} left`;
}

/** A lot's display name: its number, or a plain fallback for an unnamed one. */
export function lotName(lot: Pick<StockLot, 'lotNo'>): string {
  return lot.lotNo?.trim() || 'Unnamed lot';
}

export function lotValue(lot: Pick<StockLot, 'unitCost' | 'qtyRemaining'>): string | null {
  if (lot.unitCost == null) return null;
  return new Decimal(lot.unitCost).mul(lot.qtyRemaining).toFixed(2);
}

/** A unit cost for display: two decimals, more only when the cost needs them. */
export function costLabel(unitCost: string | null): string {
  if (unitCost == null) return 'not costed';
  const d = new Decimal(unitCost);
  return d.decimalPlaces() > 2 ? d.toString() : d.toFixed(2);
}
